// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARTICLE_EXPERIENCE_SEND = "Odo\u0161li";
export const BLOGS_ADD_NEW_COMMENT_PLACEHOLDER = "Za\u010dni p\u00edsa\u0165 koment\u00e1r...";
export const FORMS_DEFAULT_REQUIRED_FIELD_ERROR = "Toto pole je povinn\u00e9.";
